import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "circulationBusiness";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    circulationAList: {
      list: [],
      total: 0
    }, //购销单位
    circulationBList: {
      list: [],
      total: 0
    } //流通商
  },
  actions: {
    //获取流通商列表数据
    async getCirculationBData({ commit }, payload) {
      let result = await api.get(
        `/api/Dealer/Customer?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setCirculationB", result.data);
      }
      return result;
    },
    //获取购销单位列表数据
    async getCirculationAData({ commit }, payload) {
      let result = await api.get(
        `/api/Dealer?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setCirculationA", result.data);
      }
      return result;
    },
    //添加数据
    async addCirculationB(a, payload) {
      let result = await api.post("/api/Dealer", payload);
      return result.data;
    },
    //获取单条数据
    async getSingleCirculationB(a, payload) {
      let result = await api.get(`/api/Dealer/${payload}`);
      return result.data;
    },
    //修改数据
    async updateCirculationB(a, payload) {
      let result = await api.put(`/api/Dealer/`, payload);
      return result.data;
    },
    //删除数据
    async delCirculationB(a, payload) {
      let result = await api.delete(`/api/Dealer/` + payload);
      return result;
    },
    // 获取流通商下拉框列表
    async getDealerKeyValue(a, payload) {
      let result = await api.get(`/api/Customer`);
      return result.data;
    },
    //同步供销商
    async syncQlw(a, payload) {
      let result = await api.post("/api/Dealer/SyncQlw", payload);
      return result;
    }
  },
  mutations: {
    setCirculationB(state, payload) {
      state.circulationBList = payload;
    },
    setCirculationA(state, payload) {
      state.circulationAList = payload;
    }
  }
});

export default moduleName;
